<template>
  <v-row class="mb-15 fill-height">
    <v-col>
      <v-row>
        <v-col>
          <h1>Reporte de Lista Negra de Redenciones</h1>
        </v-col>
      </v-row>
      <v-row style="padding-left: 30px; margin-top: 25px"> </v-row>
      <v-row class="mb-15" style="padding-left: 30px">
        <v-col md="3">
          <h3>Selecciona el rango de fechas</h3>
          <v-date-picker
            style="width: 100%"
            v-model="dates"
            range
          ></v-date-picker>
          <v-btn
            rounded
            color="primary"
            style="width: 100%"
            dark
            @click="consultar(false)"
            >Consultar</v-btn
          >
          <v-btn
            rounded
            color="primary"
            style="width: 100%; margin-top: 20px"
            :disabled="bloquear"
            @click="consultar(true)"
          >
            Descargar Información
          </v-btn>
        </v-col>
        <v-col cols="9" md="9">
          <div>
            <div v-if="loading" style="text-align: center">
              <h2 clas="pb-4">Cargando Reporte....</h2>
              <br /><br />
              <md-progress-spinner
                :md-diameter="100"
                :md-stroke="10"
                md-mode="indeterminate"
              />
            </div>
          </div>

          <v-data-table
            :headers="columns"
            :items="items"
            item-key="name"
            class="elevation-1"
            :search="search"
            :custom-filter="filterOnlyCapsText"
            :server-items-length="totalRegistros"
            :loading="loading"
            loading-text="Cargando..."
            :items-per-page="elementosPagina"
            @update:page="pagina = $event"
            @update:items-per-page="elementosPagina = $event"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Buscar"
                class="mx-4"
              ></v-text-field>
            </template>

            <template v-slot:item.fechaAction="{ item }">
              {{item.fecha}}
            </template>
            <template v-slot:item.origen="{ item }">
              {{item.origen ? item.origen : 'No tiene'}}
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                color="success"
              >
                <v-icon style="color: red" @click="toggleStatus(true, item.id)" v-if="item.status === 1">mdi-lock-open</v-icon>
                <v-icon @click="toggleStatus(false, item.id)" v-else>mdi-lock</v-icon>
              </v-btn>
            </template>

            <!-- <template v-slot:item.urlPoliza="{ item }">
                                <v-btn :href="'https://segurify-data.s3.amazonaws.com/' + item.urlPoliza">Descargar</v-btn>
                            </template> -->
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
var moment = require("moment-timezone");
import download from "downloadjs";
import { ListExpanded } from "../../../../plugins/mixins";

export default {
  mixins: [ListExpanded],

  data() {
    return {
      dates: ["", ""],
      roles: JSON.parse(localStorage.getItem("roles")),
      agenteUuid: localStorage.getItem("agenteUuid"),
      loading: false,
      reportType: "lead",
      items: [],
      search: "",
      reportDownloadIt: [],
      reportCompleteDowload: [],
      bloquear: true,
      block: true,
      canal: null,
      canales: [
        { id: 1, name: "AGENTES" },
        { id: 2, name: "MASIVOS" },
        { id: 3, name: "DIRECTOS" },
      ],

      columns: [
        { text: "ID", value: "id" },
        { text: "Status", value: "statusEtiqueta" },
        { text: "Fecha", value: "fechaAction" },
        { text: "Telefono", value: "telefono" },
        { text: "Emisión ID", value: "emisionId" },
        { text: "Origen", value: "origen" },
        { text: "Operador", value: "nombreOperador" },
        { text: "Acción", value: "action" },
        // { text: "Tarjeta", value: "tarjeta" },
      ],
      pagina: 1,
      elementosPagina: 10,
      totalRegistros: 0,
    };
  },

  watch: {
    pagina(v) {
      !!v && this.consultar();
    },

    elementosPagina(v) {
      !!v && this.consultar();
    },
  },

  methods: {
    convertDate(date) {
      const dateRes = moment(date);
      dateRes.tz("UTC", true);
      return dateRes.tz("America/Mexico_City").format("DD-MM-YYYY HH:mm");
    },

    toggleStatus(telefonoBlock, id){ // --> telefonoBlock = true (bloqueado) o telefonoBlock (desbloqueado) se manda el contrario al back para que haga el cambio
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      let body = {
        id: id,
        status: telefonoBlock ? 0 : 1
      }
      let route = `/v1/telefonoListaNegra/changeStatus`;
      this.$axios.put(route, body, config).then(() => {
        this.$toast.success("Se actualizó el estatus del teléfono");
        this.items = this.items.map(item => {
          if(item.id === id){
            item.status = telefonoBlock ? 0 : 1
            item.statusEtiqueta = telefonoBlock ? 'Desbloqueado' : 'Bloqueado'
          }
          return item
        });
      }).catch((error) => {
        console.log(error)
        this.$toast.error("Ocurrió un error al actualizar el estatus del teléfono");
      })
    },

    async consultar(file = false) {
      this.loading = true;

      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      var inicioUTC = null;
      var finUTC = null;

      if (this.dates.length > 0) {
        if (this.dates[1]) {
          inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD 00:00:00");
          finUTC = moment.utc(this.dates[1]).format("YYYY-MM-DD 23:59:59");
        } else {
          inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD 00:00:00");
          finUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD 23:59:59");
        }
      }
      let query = {
        fechas: [inicioUTC, finUTC],
        elementos_pagina: this.elementosPagina,
        pagina: this.pagina,
      };

      let route = `/v1/telefonoListaNegra/reporte`;
      if (file) route += "/file";
      let { data } = await this.$axios.post(route, query, config);

      if (file) return this.manageFileResponse(data);

      this.items = [];

      if (data.data.total) this.totalRegistros = data.data.total;

      this.items = data.data.telefonos_lista_negra;
      if (this.items.length) this.bloquear = false;
      this.loading = false;
    },

    manageFileResponse(responseData) {
      download(
        responseData,
        `informe_lista_negra.csv`,
        "application/csv"
      );

      this.loading = false;
    },

    toCurrency(number) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(number); /* $2,500.00 */
    },
    // Table
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().indexOf(search) !== -1
      );
    },
  },
  computed: {
    blockBoton() {
      return this.canal != null && this.dates != ["", ""];
    },
    canShow() {
      var canView = false;
      var roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });
      const rolesToView = ["ADMIN", "DIRECTOR", "FINANZAS"];
      roles.forEach((element) => {
        if (rolesToView.includes(element)) {
          canView = true;
        }
      });
      return canView;
    },
    currentRol() {
      let roles = [];
      this.roles.forEach((element) => {
        if (element.rol != null) {
          roles.push(element.rol);
        }
      });

      if (roles.length > 0) {
        return roles[0];
      } else {
        return "";
      }
    },
  },
};
</script>
